module.exports = __webpack_public_path__ + "static/far_traveler-961885dfc7835add0725e96f4b00e112.png";